require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-electronic-banking-tip.json") })
        }
      }, "path---es-articles-electronic-banking-tip");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-electronic-banking-tip!./.cache/json/es-articles-electronic-banking-tip.json
// module id = 2060
// module chunks = 231608221292675